<app-tickets-info-card [ticketsInfo]="ticketsInfo$ | async" (selectedIntervalChanged)="handleIntervalChange($event)" />
